"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvestmentSolutions = InvestmentSolutions;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Starting w/ InvestmentSolutions since it's on the Figma MVP
function InvestmentSolutions(_ref) {
  var {
    handleClose,
    show
  } = _ref;
  //   const [investmentSolutionsModalOpen, setInvestmentSolutionsModalOpen] =
  //     useState(false)
  //   const stepInvestmentSolutionsClose = () => {
  //     setInvestmentSolutionsModalOpen(false)
  //   }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fpctInvestmentSolutionsModal"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Investment Solutions"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, "Stocks, bonds, mutual funds, ETFs, diversified model portfolios, and separately managed accounts are exmaples of investment solutions that can help you build wealth toward a secure retirement.", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("strong", null, "Resources"))));
}